import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  getMostRecentCustomerSalesinvoiceDetailsPrintRequest,
  MostRecentCustomerDetailsPrintRequest,
  MostRecentCustomerDetailsWithSalesInvoiceInfoBean,
  MostRecentCustomerDetailsWithSalesOrderInfoBean,
  MostRecentCustomerInquiryCriteriaBean,
  MostRecentCustomerSalesInvoiceRequest,
  MostRecentCustomerSalesOrderDetailsPrintRequest,
  MostRecentCustomerSalesOrderInfoRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString, toDownloadReportAddress } from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupInvoiceModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class MostRecentCustomerSalesDetail extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Most Recent Customer Details - Inquiry",
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlert: false,
      alertMsg: "",
      error_list: [],
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      criteria: new MostRecentCustomerInquiryCriteriaBean(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      creditMemoTypes: [],
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditTypeList: true,
      isInquiryDatasFound: false,
      inquiryDataList: [],
      summaryData: null,
      isShowCreditMemoModule: false,
      moduleForPopup: [],
      isDisableFields: false,
      isShowCustomerModule: false,
      customerList: [],
      invoiceLineList: [],
      isShowFabricStyleModule: false,
      isShowInvoiceModule: false,
      isShowSalesInvoicePopup: false,
      salesInvoiceDataList: [],
      isShowAlertLvl1: false,
      salesInvoiceCriteria:
        new MostRecentCustomerDetailsWithSalesInvoiceInfoBean(),
      isShowCustomerModule: false,
      isShowSalesOrderPopup: false,
      salesOrderDataList: [],
      salesOrderCriteria: new MostRecentCustomerDetailsWithSalesOrderInfoBean(),
      isShowSalesModule: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    const newDate = new Date(new Date().getFullYear(), 0, 1);
    const currentDay = new Date();
    criteria.fromDate = newDate;
    criteria.toDate = currentDay;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let creditMemoTypes = [];
    creditMemoTypes = attribute_cache.creditMemoTypes;
    if (!isEmptyArray(creditMemoTypes)) {
      this.state.creditMemoTypes = creditMemoTypes;
    }
    this.setState({ criteria: criteria });
  }
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearCriteria = () => {
    let criteria = new MostRecentCustomerInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isDisableFields: false,
    });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  resetInquiry = () => {
    let criteria = new MostRecentCustomerInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    const newDate = new Date(new Date().getFullYear(), 0, 1);
    const currentDay = new Date();
    criteria.fromDate = newDate;
    criteria.toDate = currentDay;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isDisableFields: false,
      customerList: [],
      invoiceLineList: [],
      salesInvoiceDataList: [],
      salesInvoiceCriteria:
        new MostRecentCustomerDetailsWithSalesInvoiceInfoBean(),
      salesOrderDataList: [],
      salesOrderCriteria: new MostRecentCustomerDetailsWithSalesOrderInfoBean(),
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new MostRecentCustomerDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      // if (
      //   SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()
      // ) {
      ReportService.getMostRecentCustomerDetailsPrintReport(
        listRequest,
        this.mostRecentCustomerSalesDetailResponse,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(2);
      // }
    } else if (reportBean.reportType == 2) {
      // if (
      //   SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()
      // ) {
      ReportService.getMostRecentCustomerDetailsPrintReport(
        listRequest,
        this.mostRecentCustomerSalesDetailResponseForExcel,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(3);
      // }
    }
  };
  mostRecentCustomerSalesDetailResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  
  mostRecentCustomerSalesDetailResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        if (!isEmptyString(reportFilePath)) {
          window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    if (!isEmptyString(criteria.fromDate) && !isEmptyString(criteria.toDate)) {
      this.loadMostRecentCustomerSalesList(criteria);
    } else {
      let errMsg = "";
      errMsg = "Enter Valid Date Range";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadMostRecentCustomerSalesList = (criteria) => {
    // if (SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()) {
    ReportService.inquireMostRecentCustomerInfo(
      criteria,
      this.loadMostRecentCustomerSalesListResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadMostRecentCustomerSalesListResponse = (response) => {
    if (response.data != null && response.data.inquireResult != null) {
      let invoiceInfoDataList = [];
      if (!isEmptyArray(response.data.inquireResult.customerInfos)) {
        invoiceInfoDataList = response.data.inquireResult.customerInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: invoiceInfoDataList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesOrderCode = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  salesOrderAmountClick = (e, val, rowData) => {
    if (e.detail === 1) {
      if (rowData.totalSalesOrderAmount > 0) {
        let salesOrderCriteria =
          new MostRecentCustomerDetailsWithSalesOrderInfoBean();
        salesOrderCriteria.companyCode = this.companyCode;
        salesOrderCriteria.customerCode = rowData.customerCode;
        salesOrderCriteria.grandTotalAmount = rowData.totalSalesOrderAmount;
        this.setState({
          salesOrderCriteria: salesOrderCriteria,
        });
        let listRequest = new MostRecentCustomerSalesOrderInfoRequest();
        listRequest.comapanyCode = salesOrderCriteria.companyCode;
        listRequest.customerCode = salesOrderCriteria.customerCode;
        if (val > 0) {
          this.loadSalesOrderListPage(listRequest);
        } else {
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
          let errMsg = "No data found";
          let errList = new Array();
          errList.push(errMsg);
          this.setState({ error_list: errList });
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  loadSalesOrderListPage = (listRequest) => {
    // if (SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()) {
    ReportService.inquireMostRecentCustomerSalesOrderInfo(
      listRequest,
      this.loadMostRecentCustomerSalesOrderPageListResponse,
      this.errorCallBack
    );
    //}
  };
  loadMostRecentCustomerSalesOrderPageListResponse = (response) => {
    if (response.data != null) {
      let invoiceInfoDataList = [];
      if (!isEmptyArray(response.data.salesOrderInfos)) {
        invoiceInfoDataList = response.data.salesOrderInfos;
        this.setState({
          salesOrderDataList: invoiceInfoDataList,
          isShowSalesOrderPopup: true,
        });
      }
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowSalesOrderPopup: true,
    });
  };
  salesInvoiceAmountClick = (e, val, rowData) => {
    if (e.detail === 1) {
      if (rowData.totalSalesInvoiceAmount > 0) {
        let salesInvoiceCriteria =
          new MostRecentCustomerDetailsWithSalesInvoiceInfoBean();
        salesInvoiceCriteria.companyCode = this.companyCode;
        salesInvoiceCriteria.customerCode = rowData.customerCode;
        salesInvoiceCriteria.grandTotalAmount = rowData.totalSalesInvoiceAmount;
        salesInvoiceCriteria.dueAmount = rowData.totalDueAmount;
        this.setState({
          salesInvoiceCriteria: salesInvoiceCriteria,
        });
        let listRequest = new MostRecentCustomerSalesInvoiceRequest();
        listRequest.companyCode = this.companyCode;
        listRequest.customerCode = salesInvoiceCriteria.customerCode;
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading...",
        });
        if (val > 0) {
          this.loadSalesOrderInvoiceListPage(listRequest);
        } else {
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
          let errMsg = "No data found";
          let errList = new Array();
          errList.push(errMsg);
          this.setState({ error_list: errList });
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  loadSalesOrderInvoiceListPage = (listRequest) => {
    // if (SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()) {
    ReportService.inquireMostRecentCustomerSalesInvoiceInfo(
      listRequest,
      this.loadMostRecentCustomerSalesInvoicePageListResponse,
      this.errorCallBack
    );
    // }
  };
  loadMostRecentCustomerSalesInvoicePageListResponse = (response) => {
    if (response.data != null) {
      let invoiceInfoDataList = [];
      if (!isEmptyArray(response.data.salesInvoiceInfos)) {
        invoiceInfoDataList = response.data.salesInvoiceInfos;
        this.setState({
          salesInvoiceDataList: invoiceInfoDataList,
          isShowSalesInvoicePopup: true,
        });
      }
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeAlertModalCallBack01 = (isShowPopup) => {
    this.setState({
      isShowSalesInvoicePopup: isShowPopup,
      isShowSalesOrderPopup: isShowPopup,
      isShowAlertLvl1: isShowPopup,
    });
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl1: isDisplayed });
  };
  generateSalesInvoicePdf = () => {
    this.generateSalesInvoiceReport(1);
  };
  generateSalesInvoiceExcel = () => {
    this.generateSalesInvoiceReport(2);
  };
  generateSalesInvoiceReport = (reportType) => {
    let criteria = this.state.salesInvoiceCriteria;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest =
      new getMostRecentCustomerSalesinvoiceDetailsPrintRequest();
    listRequest.comapanyCode = criteria.companyCode;
    listRequest.customerCode = criteria.customerCode;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      // if (
      //   SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()
      // ) {
      ReportService.getMostRecentCustomerSalesinvoiceDetailsPrintReport(
        listRequest,
        this.mostRecentCustomerSalesInvoiceDetailResponse,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(2);
      // }
    } else if (reportBean.reportType == 2) {
      // if (
      //   SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()
      // ) {
      ReportService.getMostRecentCustomerSalesinvoiceDetailsPrintReport(
        listRequest,
        this.mostRecentCustomerSalesInvoiceDetailResponse,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(3);
      // }
    }
  };
  mostRecentCustomerSalesInvoiceDetailResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateSalesOrderPdf = () => {
    this.generateSalesOrderReport(1);
  };
  generateSalesOrderExcel = () => {
    this.generateSalesOrderReport(2);
  };
  generateSalesOrderReport = (reportType) => {
    let criteria = this.state.salesOrderCriteria;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new MostRecentCustomerSalesOrderDetailsPrintRequest();
    listRequest.comapanyCode = criteria.companyCode;
    listRequest.customerCode = criteria.customerCode;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      // if (
      //   SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()
      // ) {
      ReportService.getMostRecentCustomerSalesOrderDetailsPrintReport(
        listRequest,
        this.mostRecentCustomerSalesOrderDetailReport,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(2);
      // }
    } else if (reportBean.reportType == 2) {
      // if (
      //   SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible()
      // ) {
      ReportService.getMostRecentCustomerSalesOrderDetailsPrintReport(
        listRequest,
        this.mostRecentCustomerSalesOrderDetailReport,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(3);
      // }
    }
  };
  mostRecentCustomerSalesOrderDetailReport = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderAmt", "totalSalesOrderAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.salesOrderAmountClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceAmt", "totalSalesInvoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.salesInvoiceAmountClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Due Amount", "totalDueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Currency", "currencyCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerDeliveryType", "customerDeliveryTypeCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerType", "customerTypeCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShipVia", "shipViaCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PaymentTerm", "paymentTermsCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Address", "address", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getAddress)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("City", "address", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCity)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("State", "address", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getState)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Country", "address", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCountry)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Email", "address", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getEmail)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Mobile", "address", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getMobileNumber)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Phone", "address", true)
        .setStyleDetails("left", "4", "", "wt-6", "wt-6")
        .setStatusDetails(true, this.getPhone)
    );

    return columns;
  };
  getAddress = (value) => {
    let address = "";
    address = value.address1;
    return address;
  };
  getCity = (value) => {
    let city = "";
    city = value.city;
    return city;
  };
  getState = (value) => {
    let state = "";
    state = value.state;
    return state;
  };
  getCountry = (value) => {
    let country = "";
    country = value.country;
    return country;
  };
  getEmail = (value) => {
    let email = "";
    email = value.email;
    return email;
  };
  getMobileNumber = (value) => {
    let mobileNumber = "";
    mobileNumber = value.mobilePhone;
    return mobileNumber;
  };
  getPhone = (value) => {
    let phone1 = "";
    phone1 = value.phone1;
    return phone1;
  };

  customerSalesColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("S.o#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewSalesOrderCode, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer Name", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "grandTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  customerSalesInvoiceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer Name", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "grandTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PaidAmount", "paidAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DueAmount", "dueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let salesInvoiceCriteria = this.state.salesInvoiceCriteria;
    let salesInvoiceDataList = this.state.salesInvoiceDataList;
    let salesOrderDataList = this.state.salesOrderDataList;
    let salesOrderCriteria = this.state.salesOrderCriteria;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          onChange={this.onChange}
          creditTypeOnChange={this.creditTypeOnChange}
          creditTypeEnterKeyEvent={this.creditTypeEnterKeyEvent}
          displayCreditTypeAutoCompleteList={
            this.displayCreditTypeAutoCompleteList
          }
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              enableVritualizer={true}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowSalesModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel10"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowSalesInvoicePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack01}
          title={"CustomerSalesInvoiceDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateSalesInvoicePdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateSalesInvoiceExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={salesInvoiceCriteria.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>TotalAmt</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="grandTotalAmount"
                    className="text-right"
                    value={salesInvoiceCriteria.grandTotalAmount}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Due AMt</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name={"dueAmount"}
                    className="text-right"
                    value={salesInvoiceCriteria.dueAmount}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={salesInvoiceDataList}
                  columns={this.customerSalesInvoiceColumns()}
                  label={"Customer Sales Invoice Details"}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowSalesOrderPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack01}
          title={"CustomerSalesOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateSalesOrderPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateSalesOrderExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={salesOrderCriteria.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>TotalAmt</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="grandTotalAmount"
                    className="text-right"
                    value={salesOrderCriteria.grandTotalAmount}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={salesOrderDataList}
                  columns={this.customerSalesColumns()}
                  label={"Company SalesOrder Details"}
                />
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      creditMemoTypes: this.props.creditMemoTypes,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  showDataOnChange = (e) => {
    this.props.showDataOnChange(e);
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };
  creditTypeOnChange = (e) => {
    this.props.creditTypeOnChange(e);
  };
  creditTypeEnterKeyEvent = (e) => {
    this.props.creditTypeEnterKeyEvent(e);
  };
  displayCreditTypeAutoCompleteList = () => {
    this.props.displayCreditTypeAutoCompleteList();
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    let customerList = this.props.customerList;
    let isInquiryDatasFound = this.props.isInquiryDatasFound;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>from Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromDate"
              onChange={this.onChange}
              value={criteria.fromDate}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toDate"
              onChange={this.onChange}
              value={criteria.toDate}
              disabled={isDisableFields}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
function MostRecentCustomerSalesDetailInquiry(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <MostRecentCustomerSalesDetail {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default MostRecentCustomerSalesDetailInquiry;
